import { ElementRef } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncSubject } from 'rxjs';
import * as Highcharts from 'highcharts/highstock';
import { SeriesOptionsType } from 'highcharts';
import { take } from 'rxjs/operators';

export class StockChart {
  public refSubject: AsyncSubject<Highcharts.Chart> = new AsyncSubject();
  public ref$: Observable<Highcharts.Chart> = this.refSubject.asObservable();
  public ref?: Highcharts.Chart;

  public constructor(public options: Highcharts.Options = { series: [] }) { }

  public init(el: ElementRef): void {
    Highcharts.stockChart(el.nativeElement, this.options, (chart: any) => {
      this.refSubject.next(chart);
      this.ref = chart;
      this.refSubject.complete();
    });
  }

  public destroy(): void {
    if (this.ref) {
      this.options = this.ref.options;
      this.ref.destroy();
      this.ref = undefined;

      this.refSubject = new AsyncSubject();
      this.ref$ = this.refSubject.asObservable();
    }
  }

  public addSerie(serie: SeriesOptionsType, redraw = true): void {
    this.ref$.subscribe(chart => {
      chart.addSeries(serie, redraw);
    });
  }

  public removeSerie(serieIndex: number): void {
    this.ref$.subscribe(chart => {
      if (chart.series.length > serieIndex) {
        chart.series[serieIndex].remove(true);
      }
    });
  }

  public removeAllSeries(): void {
    this.ref$.pipe(take(1)).subscribe(chart => {
      while (chart.series.length > 0) {
        chart.series[0].remove(chart.series.length === 0);
      }
    });
  }

  public getRef(): Highcharts.Chart | undefined {
    return this.ref;
  }

  public setExtremes(from: number, to: number): void {
    if (this.ref) {
      this.ref.xAxis[0].setExtremes(from, to);
    }
  }

  public setExtremesFrom(from: number): void {
    if (this.ref) {
      this.ref.xAxis[0].setExtremes(from, this.ref.xAxis[0].getExtremes().max);
    }
  }

  public setExtremesTo(to: number): void {
    if (this.ref) {
      this.ref.xAxis[0].setExtremes(this.ref.xAxis[0].getExtremes().min, to);
    }
  }

  public setRangeSelection(selected: number): void {
    if (this.ref) {
      this.ref.update({ rangeSelector: { selected } });
    }
  }
}
